import Create from './create'
import { mapGetters } from 'vuex'
import Status from '@/status'
import swal from 'sweetalert'
export default {
  name: 'group-alias',
  components: {Create},
  props: [],
  data () {
    return {
      per_page: 'all',
      group_alias: {},
      errors: {},
      btn_submit: false
    }
  },
  computed: {
    ...mapGetters({
      group_aliases: 'GroupAlias/getListGroupAlias',
      groups: 'Group/getListGroup'
    })
  },
  mounted () {
    this.$loading.start()
    Promise.all([
      this.$store.dispatch('GroupAlias/getListGroupAlias', {page: 1, per_page: this.per_page}),
      this.$store.dispatch('Group/getListGroup', {page: 1, per_page: 'all', status: Status.APPROVAL})
    ]).then(res => {
      this.$loading.complete()
    }).catch(errors => {
      this.$loading.fail()
    })
  },
  methods: {
    showModel (group_alias = {}) {
      this.errors = {}
      this.$loading.start()
      this.$store.dispatch('GroupAlias/showGroupAlias', {group_alias}).then(res => {
        this.group_alias = res
        this.group_alias.grp_id = res.group ? res.group.id + '' : ''
        this.$refs.edit.show()
        this.$loading.complete()
      }).catch(errors => {
        console.log(errors)
        this.$loading.fail()
      })
    },
    update () {
      this.btn_submit = true
      this.$loading.start()
      this.$store.dispatch('GroupAlias/updateGroupAlias', {group_alias: this.group_alias}).then(res => {
        this.$refs.edit.hide()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        this.btn_submit = false
        this.$loading.complete()
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.btn_submit = false
        this.$loading.fail()
      })
    },
    destroy (group_alias = {}) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$loading.start()
            this.$store.dispatch('GroupAlias/destroyGroupAlias', {
              group_alias
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.$loading.complete()
            }).catch(errors => {
              this.$loading.complete()
            })
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/group-alias/group-alias.js